<script setup>
import {computed} from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import AdminReservationChange from "./AdminReservationChange.vue";
import AdminNewReservationWrapper from "./AdminNewReservationWrapper.vue";

const model = defineModel();

const visibleDialog = computed({
    get: () => !!model.value,
    set: (val) => model.value = !!val
})

const dialogContent = computed(() => {
    switch (model.value?.type) {
        case 'App\\Notifications\\AdminNewReservation':
        case 'App\\Notifications\\AdminReservationChangeByUser':
            return AdminNewReservationWrapper;

        case 'App\\Notifications\\AdminReservationChange':
        default:
            return AdminReservationChange;
    }
})

const dialogWidth = computed(() => {
    switch (model?.value?.type) {
        case 'App\\Notifications\\AdminNewReservation':
        case 'App\\Notifications\\AdminReservationChangeByUser':
            return 800;

        case 'App\\Notifications\\AdminReservationChange':
        default:
            return 400;
    }
})

const emit = defineEmits(['read']);
</script>

<template>
    <Dialog v-model:visible="visibleDialog" modal class="overflow-hidden" :class="`md:min-w-[${dialogWidth}px]`">
        <template #container>
            <div class="bg-neutral-100 dark:bg-neutral-800 dark:border-neutral-700 border-b p-4 flex gap-8 justify-between items-center">
                <p class="font-bold">
                    {{model.data.message}}
                </p>
                <Button rounded icon="pi pi-times" severity="secondary" size="small" outlined @click="visibleDialog = false"></Button>
            </div>
            <component :is="dialogContent" :notification="model" @close="() => { emit('read'); visibleDialog = false; }"/>
        </template>
    </Dialog>
</template>

<style scoped lang="scss">

</style>
